import store from '../state/store'
import Vue from 'vue'

export default [
 
  {
    path: '/login',
    name: 'login', 
    component: () => import('./views/account/login') 
  },  
  {
    path: '/logout',
    name: 'logout', 
    beforeEnter(to,from,next){  
    store.dispatch("auth/logOut") 
        next() 
    },
     
  },
  {
    path: '/forgot-password',
    name: 'login', 
    component: () => import('./views/account/forgot-password') 
  }, 
  {
    path: '/',
    name: 'default',
    component: () => import('./views/anasayfa/index') 
  }, 
  {
    path: '/mznmezunlar',
    name: 'mznmezunlar', 
    component: () => import('./views/mznmezunlar/index') 
  }, 
  {
    path: '/profil/:MznId',
    name: 'profil',
    component: () => import('./views/mznmezunlar/profil'),
 
  }, 
  {
    path: '/mznisilanlari/:FirmaId',
    name: 'firma',
    component: () => import('./views/mznisilanlari/firma'),
 
  }, 
  {
    path: '/newsdetail/:LangId/:Title/:NewsId',
    name: 'newsdetail',
    component: () => import('./views/news/newsdetail'),
 
  },

  {
    path: '/fullnews/:LangId',
    name: 'fullnews',
    component: () => import('./views/news/fullnews'),
 
  },
  {
    path: '/fullnotices/:LangId',
    name: 'fullnotices',
    component: () => import('./views/news/fullnotices'),
 
  },
  {
    path: '/profiledit',
    name: 'profiledit', 
    component: () => import('./views/mznmezunlar/profiledit') 
  },
  {
    path: '/profilzorunlubilgiler',
    name: 'profilzorunlubilgiler', 
    component: () => import('./views/mznmezunlar/profilzorunlubilgiler') 
  },
  {
    path: '/maps',
    name: 'maps', 
    component: () => import('./views/mznmezunlar/maps') 
  },
  {
    path: '/contactforms/:LangId',
    name: 'contactforms',
    component: () => import('./views/contactforms/index'),
 
  },
  {
    path: '/veritabanlari/:LangId',
    name: 'veritabanlari',
    component: () => import('./views/veritabanlari/index'),
 
  },
  {
    path: '/aboneveritabanlari/:LangId',
    name: 'aboneveritabanlari',
    component: () => import('./views/aboneveritabanlari/index'),
 
  },
  {
    path: '/komisyonlar',
    name: 'komisyonlar',
    component: () => import('./views/komisyonlar/index'),
 
  },
  {
    path: '/page/:LangId/:Title/:DpagesId',
    name: 'dpages',
    component: () => import('./views/dpages/index'),
 
  },
  {
    path: '/fullactivities/:LangId',
    name: 'fullactivities',
    component: () => import('./views/activities/fullactivities'),
 
  },
  {
    path: '/activitydetails/:LangId/:Title/:ActivityId',
    name: 'activitydetails',
    component: () => import('./views/activities/activitydetails'),
 
  },
  {
    path: '/veritabanidetails/:LangId/:Title/:VeritabaniId',
    name: 'veritabanidetails',
    component: () => import('./views/veritabanlari/veritabanidetails'),
 
  },
  {
    path: '/aboneveritabanidetails/:LangId/:Title/:AboneveritabaniId',
    name: 'aboneveritabanidetails',
    component: () => import('./views/aboneveritabanlari/aboneveritabanidetails'),
 
  },
  {
    path: '/komisyonpersoneller/:KomisyonId',
    name: 'komisyonpersoneller',
    component: () => import('./views/komisyonlar/komisyonpersoneller'),
 
  },
  {
    path: '/userroles',
    name: 'userroles', 
    component: () => import('./views/userroles/index'), 
     beforeEnter(to,from,next){  
          if(store.getters.["auth/isAuth"]){
          next() 
          }else{
            window.location=Vue.prototype.$config.LOGIN_URL 
          }
     }
  },
  {
    path: '/ofirma',
    name: 'ofirma', 
    component: () => import('./views/ofirma/index'), 
     beforeEnter(to,from,next){  
          if(store.getters.["auth/isAuth"]){
          next() 
          }else{
            window.location=Vue.prototype.$config.LOGIN_URL 
          }
     }
  },
  {
    path: '/idaripersonel/:LangId',
    name: 'IdariPersoneller', 
    component: () => import('./views/personeller/idaripersoneller'), 
     beforeEnter(to,from,next){  
          if(store.getters.["auth/isAuth"]){
          next() 
          }else{
            window.location=Vue.prototype.$config.LOGIN_URL 
          }
     }
  },
  {
    path: '/akademikpersonel/:LangId',
    name: 'AkademikPersoneller', 
    component: () => import('./views/personeller/akademikpersoneller'), 
     beforeEnter(to,from,next){  
          if(store.getters.["auth/isAuth"]){
          next() 
          }else{
            window.location=Vue.prototype.$config.LOGIN_URL 
          }
     }
  },
  {
    path: '/mznisilanlari',
    name: 'mznisilanlari', 
    component: () => import('./views/mznisilanlari/index') 
  },
  {
    path: '/mznisilanlarifirma',
    name: 'mznisilanlarifirma', 
    component: () => import('./views/mznisilanlari/firma') 
  }, 
  {
    path: '/mzneposta',
    name: 'mzneposta', 
    component: () => import('./views/mzneposta/index') 
  },
  {
    path: '/fakulteyonetimkurulu',
    name: 'fakulteyonetimkurulu', 
    component: () => import('./views/personeller/fakulteyonetimkurulu') 
  }, 
  {
    path: '/fakultekurulu',
    name: 'fakultekurulu', 
    component: () => import('./views/personeller/fakultekurulu')
  }, 
  {
    path: '/api/account/confirm-email/',
    name: 'default',
    component: () => import('./views/utility/confirm-email'),
 
  },
  {
    path: '/404',
    name: '404',
    component: require('./views/utility/404').default,
  }, 
  {
    path: '*',
    redirect: '404',
  }
  
]
